<template>
  <div class="app-container">
    <div class="topic-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input @keyup.enter.native="searchChange" class="topic-list-filter-value" placeholder="分类名称" v-model.trim="keywords" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="topic-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="topic-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-button class="topic-list-filter-search" size="small" @click="onClickSyncCache">同步缓存</el-button>
            <el-button class="topic-list-filter-search" size="small" @click="onClickRemoveCache">清除缓存</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  <basic-container>
    <avue-crud
      ref="crudItem"
      :page="pageItem"
      :data="tableDictItemData"
      @current-change="currentChangeItem"
      @size-change="sizeChangeItem"
      v-model="form"
      @row-update="handleItemUpdate"
      @row-save="handleItemSave"
      @row-del="rowItemDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @sort-change="handleSortChangeDictItem"
      @refresh-change="handleRefreshChange"
      :before-open="handleBeforeOpen"
      :option="tableDictItemClassificationOption"
      :table-loading="tagManagementTableLoading"
    >
      <template slot="sortForm">
        <el-input-number size="medium" v-model="form.sort" :precision="0" :step="1" :min="0" controls-position="right" @change="checkSortValue"></el-input-number>
      </template>
      <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.classification_add">新增分类</el-button>
        </template>
      <template slot="search">
        <el-form-item label="标签">
          <el-input @keyup.enter.native="searchChange" v-model="keywords" size="small"></el-input>
        </el-form-item>
        <el-form-item label="编码">
          <el-input @keyup.enter.native="searchChange" v-model="tagCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="small" v-model="status">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>
      </template>

      <template slot-scope="scope" slot="menu">
        <!-- <el-button
          v-if="permissions.classification_edit"
          title="复制链接"
          size="mini"
          type="text"
          icon="el-icon-share"
          @click="copyLink(scope.row.id)">复制链接</el-button> -->
        <el-button
          v-if="permissions.classification_edit"
          title="编辑"
          size="mini"
          type="text"
          icon="el-icon-edit"
          @click="handleEdit(scope.row, scope.index, scope.done)">编辑</el-button>
        <el-button type="text"
            title="删除"
            v-if="permissions.classification_del"
            icon="el-icon-delete"
            size="mini"
            @click="handleDel(scope.row)">删除</el-button>
        <el-button type="text"
            title="关联话题"
            v-if="permissions.classification_relatedTag"
            icon="icon-relation"
            size="mini"
            @click="handleRelate(scope.row,scope.index)">关联话题</el-button>
      </template>
    </avue-crud>
  </basic-container>
    <el-dialog
      title="关联话题"
      :visible.sync="dialogRelateFormVisible"
      width="70%"
      @close="cancelDialogRelateForm"
    >
      <div class="related-list-filter">
        <el-row>
          <el-col :span="7">
            <div class="grid-content bg-purple">
              <label class="related-list-filter-label">话题</label>
              <el-input class="related-list-filter-value" placeholder="话题" @keyup.enter.native="searchRelateChange" v-model.trim="relationKeywords" clearable size="small"></el-input>
            </div>
          </el-col>
          <div>
            <el-button class="related-list-filter-reset" size="small" @click="searchRelationReset">清除条件</el-button>
            <el-button class="related-list-filter-search" size="small" @click="searchRelateChange">立即筛选</el-button>
          </div>
        </el-row>
      </div>
      <avue-crud
        ref="crudTagRelation"
        @current-change="currentChangePageRelationItem"
        @size-change="sizeChangePageRelationItem"
        @sort-change="handleSortChangeTagRelation"
        :page="pageRelationItem"
        :data="tableTagRelationData"
        :option="tableTagRelationTopicOption"
        :table-loading="tagRelationTableLoading"
      >
        <template slot="menuLeft">
          <el-button icon="el-icon-plus" type="primary" size="small" @click="addRelatedTag" v-if="permissions.classification_relatedTag_add">新增</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text"
            v-if="permissions.classification_relatedTag_del"
            icon="icon-delete"
            size="mini"
            @click="handleRelateDelete(scope.row, scope.index)"></el-button>
        </template>
      </avue-crud>
    </el-dialog>

    <el-dialog
      title="新增关联话题"
      :visible.sync="dialogAddRelateFormVisible"
      width="30%"
      @close="cancelDialog"
    >
      <el-form :model="newRelateFrom" label-position="top">
        <el-form-item size="small">
          <v-select
            class="vSelect"
            multiple
            label="name"
            v-model="selected"
            placeholder="请选择话题"
            :closeOnSelect="false"
            :resetOnOptionsChange="false"
            :filterable="false"
            :options="tagList"
            @search="search"
            :clearSearchOnBlur="clearSearchOnBlur"
            :selectable="option => selected.indexOf(option) === -1"
            ref="v-select"
          >
            <li slot="list-footer" class="pagination">
              <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="this.pageSelectItem.current"
                :page-size="this.pageSelectItem.size"
                :pager-count="6"
                :layout="pageLayout"
                :total="this.pageSelectItem.total"
              ></el-pagination>
            </div>
            </li>
            <template #open-indicator="{ attributes }">
              <i class="el-icon-arrow-down" v-bind="attributes"></i>
            </template>
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                没有搜索结果 <em>{{ search }}</em>
              </template>
              <em style="opacity: 0.5;" v-else>输入要搜索的标签</em>
            </template>
          </v-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="addRelationForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  putItemObj,
  addNewClassfication,
  delItemObj,
  delRelateTagObj,
  fetchRelateItemList,
  addRelationClassification,
  syncClassificationCache,
  removeClassificationCache,
} from '@/api/basic/classification';
import {
  fetchItemList,
} from '@/api/basic/tagtype';
import {
  tableDictItemClassificationOption,
  statusOptions,
  tableTagRelationTopicOption,
} from '@/const/crud/basic/tagtype';
import { mapGetters } from 'vuex';
import { VueSelect } from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { debounce } from 'lodash';

export default {
  name: 'tagtype',
  components: {
    'v-select': VueSelect,
  },
  activated: function () {
    this.getDictItemList();
  },
  data() {
    return {
      form: {},
      dictId: 2, // 分类
      status: undefined,
      keywords: '',
      tagCode: '',
      relationKeywords: '',
      dialogFormVisible: true,
      tableData: [],
      tableDictItemData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageRelationItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageItem: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
      },
      pageSelectItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pages: 0,
      },
      listQuery: {
        current: 1,
        size: 10,
        status: '',
      },
      tableLoading: false,
      tagManagementTableLoading: false,
      tagRelationTableLoading: false,
      tableDictItemClassificationOption,
      statusOptions,
      dialogRelateFormVisible: false,
      tableTagRelationData: [],
      tableTagRelationTopicOption,
      dialogAddRelateFormVisible: false,
      tableAddTagRelationData: {},
      tagTypeList: [],
      searchTagTypeList: [],
      newRelateFrom: {},
      searchRelateForm: {},
      relatedTagIds: [],
      tagList: [],
      selected: [],
      searchSelect: '',
      pageLayout: 'total, prev, pager, next',
      pageRelationItemTagId: '',
      tagItemSort: {
        sortField: 'sort',
        sortPolicy: 'ASC',
      },
      tagRelationSort: [],
    };
  },
  created() {
    this.getDictItemList();
  },
  mounted: function () {},
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    handleAdd() {
      this.$router.push({path: `/content/classification/add`})
    },
    handleEdit(row, index, done) {
      this.$refs.crudItem.rowEdit(row, index, done)
    },
    handleDel(row) {
      this.$refs.crudItem.rowDel(row)
    },
    getDictItemList() {
      this.tagManagementTableLoading = true;
      fetchItemList(
        Object.assign(
          {
            current: this.pageItem.currentPage,
            size: this.pageItem.pageSize,
          },
          { type: this.dictId },
          { keywords: this.keywords },
          { status: this.status },
          { tagCode: this.tagCode },
          { sortField: this.tagItemSort.sortField },
          { sortPolicy: this.tagItemSort.sortPolicy },

        )
      ).then((response) => {
        this.tableDictItemData = this.formatData(response.data.data.records);
        this.pageItem.total = response.data.data.total;
        this.tagManagementTableLoading = false;
      });
    },
    handleRefreshChange() {
      this.getDictItemList();
    },
    getRelateItemList(tagId, typeId) {
      this.dialogRelateFormVisible = true;
      this.tagRelationTableLoading = true;
      fetchRelateItemList(
        {
          current: this.pageRelationItem.currentPage,
          size: this.pageRelationItem.pageSize,
          typeId: typeId,
          keywords: this.relationKeywords,
          sortField: this.tagRelationSort.sortField,
          sortPolicy: this.tagRelationSort.sortPolicy
        },
        tagId
      ).then((response) => {
        this.tableTagRelationData = response.data.data.records;
        this.pageRelationItem.total = response.data.data.total;
        this.tagRelationTableLoading = false;
      });
    },

    handleSortChangeDictItem(val) {
      if (val.prop === "sort") {
        this.tagItemSort.sortField = "sort"
      } else {
        this.tagItemSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagItemSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagItemSort.sortPolicy = "desc"
      } else {
        this.tagItemSort.sortPolicy = ""
      }
      this.getDictItemList(this.dictId);
    },

    handleSortChangeTagRelation(val) {
      if (val.prop === "sort") {
        this.tagRelationSort.sortField = "sort"
      } else {
        this.tagRelationSort.sortField = ""
      }
      // 检查排序方式
      if (val.order === 'ascending') {
        this.tagRelationSort.sortPolicy = "asc"
      } else if (val.order === 'descending') {
        this.tagRelationSort.sortPolicy = "desc"
      } else {
        this.seatagRelationSortrch.sortPolicy = ""
      }
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    copyLink(tagId) {
      const url = process.env.VUE_APP_BASIC_PAGE_PATH + `/home?tagId=${tagId}`
      this.$copyText(url).then(
        res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '已成功复制'
          })
        },
        err => {
          this.$message({
            showClose: true,
            type: 'error',
            message: '失败'
          })
        }
		  )
    },
    formatData(records) {
      if (Array.isArray(records)) {
        records.forEach((x) => {
          if (!x.creator) {
            x.creator = 'system';
          }
        });
      }
      return records;
    },
    searchReset() {
      this.status = '';
      this.keywords = '';
      this.tagCode = '';
      this.searchChange();
    },
    onClickSyncCache() {
      var _this = this;
      _this.$confirm('请确认是否需要启用缓存？如有更新操作需重新同步。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return syncClassificationCache({ id: _this.dictId });
      }).then(() => {
        _this.$message({
          showClose: true,
          message: '同步成功',
          type: 'success',
        });
      }).catch(function (err) {
        if (err == 'cancel') {
          return;
        }
        _this.$message({
          showClose: true,
          message: '同步失败',
          type: 'error',
        });
      });
    },
    onClickRemoveCache() {
      var _this = this;
      _this.$confirm('请确认是否禁用缓存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return removeClassificationCache({ id: _this.dictId });
      }).then(() => {
        _this.$message({
          showClose: true,
          message: '禁用成功',
          type: 'success',
        });
      }).catch(function (err) {
        if (err == 'cancel') {
          return;
        }
        _this.$message({
          showClose: true,
          message: '禁用失败',
          type: 'error',
        });
      });
    },
    searchChange() {
      this.pageItem.currentPage = 1;
      this.getDictItemList(this.dictId);
    },
    searchRelationReset() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.searchRelateChange();
    },
    searchRelateChange(params) {
      this.pageRelationItem.currentPage = 1;
      this.getRelateItemList(
        this.newRelateFrom.tagId,
        this.searchRelateForm.tagTypeId
      );
    },
    currentChange(val) {
      this.page.current = val;
      this.listQuery.current = val;
      this.getList();
    },
    sizeChange(val) {
      this.page.size = val;
      this.listQuery.size = val;
      this.getList();
    },
    currentChangeItem(val) {
      this.pageItem.current = val;
      this.pageItem.currentPage = val;
      this.getDictItemList(this.dictId);
    },
    sizeChangeItem(val) {
      this.pageItem.size = val;
      this.pageItem.pageSize = val;
      this.getDictItemList(this.dictId);
    },
    currentChangePageRelationItem(val) {
      this.pageRelationItem.currentPage = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    sizeChangePageRelationItem(val) {
      this.pageRelationItem.pageSize = val;
      this.getRelateItemList(this.pageRelationItemTagId);
    },
    handleItemSave: function (row, done) {
      row.type = this.dictId;
      row.status = 1;
      addNewClassfication(row)
        .then(() => {
          this.tableDictItemData.push(Object.assign({}, row));
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success',
          });
          this.getDictItemList(row.dictId);
          this.getList(this.page);
          done();
        })
        .catch((error) => {});
    },
    handleItemUpdate: function (row, index, done, loading) {
      row.type = this.dictId;
      putItemObj(row)
        .then(() => {
          /** this.tableData.splice(index, 1, Object.assign({}, row)) */
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success',
          });
          this.getDictItemList(row.dictId);
          done();
        })
        .catch((error) => {
          loading();
        });
    },
    handleBeforeOpen(done) {
      this.form.dictId = this.dictId;
      done();
    },

    rowItemDel: function (row) {
      var _this = this;
      this.$confirm(`是否确认删除 "${row.name}" 分类?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delItemObj(row.id);
        })
        .then(() => {
          this.getDictItemList(this.dictId, row.type),
            _this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            });
        })
        .catch(function () {});
    },
    handleRelate(row, index) {
      this.pageItem.currentPage = 1;
      this.tagRelationTableLoading = true;
      this.dialogRelateFormVisible = true;
      this.getRelateItemList(row.id);
      this.newRelateFrom.tagId = row.id;
      this.pageRelationItemTagId = row.id;
      // this.listTagType();
    },
    handleRelateDelete(row, index) {
      var _this = this;
      this.$confirm('是否确认取消与"' + row.name + '"话题的关联?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function () {
          return delRelateTagObj(row.relatedId);
        })
        .then(() => {
          this.getRelateItemList(row.tagId);
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          });
        })
        .catch(function () {});
    },
    // 新增关联标签
    addRelatedTag() {
      this.dialogAddRelateFormVisible = true;
      this.tagTypeChange(3);
    },
    tagTypeChange(typeId) {
      if (typeId != null) {
        this.newRelateFrom.tagTypeId = typeId;
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.tagList.search = '';
        this.handleCurrentChange(1);
      }
    },
    tagListSearch(search) {
      if (!this.newRelateFrom.tagTypeId) {
        return;
      }
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId },
          { keywords: search }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;

        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },
    resultFormat(resp) {
      var gridResult = [];
      gridResult.list = resp.data.data.records;
      gridResult.totalRow = resp.data.data.total;
      return gridResult;
    },

    //批量添加关联标签
    addRelationForm() {
      const tagRelations = [];
      this.relatedTagIds = this.selected;
      this.relatedTagIds.forEach((item) => {
        tagRelations.push({
          tagId: this.newRelateFrom.tagId,
          relatedTagId: item.id,
        });
      });
      addRelationClassification(tagRelations).then(() => {
        this.newRelateFrom.tagTypeId = '';
        this.pageSelectItem.currentPage = 1;
        this.selected = [];
        this.dialogAddRelateFormVisible = false;
        this.getRelateItemList(this.newRelateFrom.tagId);
      });
    },

    cancelDialog() {
      this.newRelateFrom.tagTypeId = '';
      this.selected = [];
      this.tagList = [];
      this.pageSelectItem.total = '';
      this.pageLayout = 'total';
      this.dialogAddRelateFormVisible = false;
    },

    cancelDialogForm() {
      this.keywords = '';
      this.dialogFormVisible = false;
    },

    cancelDialogRelateForm() {
      this.relationKeywords = '';
      this.searchRelateForm.tagTypeId = '';
      this.dialogRelateFormVisible = false;
    },

    handleCurrentChange(val) {
      this.pageSelectItem.currentPage = val
      fetchItemList(
        Object.assign(
          {
            current: this.pageSelectItem.currentPage,
            size: this.pageSelectItem.size,
          },
          { type: this.newRelateFrom.tagTypeId }
        )
      ).then((res) => {
        const code = res.data.code;
        const data = res.data.data;
        if (code === 0 && data) {
          this.tagList = data.records;
          this.pageSelectItem.pages = data.pages;
          this.pageSelectItem.total = data.total;
          if (this.pageSelectItem.total === 0) {
            this.pageLayout = 'total';
          } else {
            this.pageLayout = 'total, prev, pager, next';
          }
        }
      });
    },

    getTagList: debounce(function() {
      this.tagListSearch(this.searchSelect)}, 300),

    search(searchKeywords) {
      this.searchSelect = searchKeywords;
      this.getTagList();
    },

    checkSortValue() {
      if (this.form.sort > 10000) {
        this.$message({
          showClose: true,
          message: "最大值为10000",
          type: 'error'
        });
      }
    }

  },
};
</script>

<style lang="scss" scoped>
.topic-list-filter {
  margin: 0 10px;
  /deep/ .el-input__inner {
    border: none;
    font-size: 14px;
  }
  .el-row {
    width: 95%;
  }
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: 96% !important;
  }
  &-search {
    float: right;
    margin-right: 8px;
  }
  &-reset {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
/deep/ .icon-relation {
  width: 12px;
  height: 13px;
  margin-bottom: -2px;
}
/deep/ .v-select.vSelect {
  .vs__dropdown-toggle {
    .vs__selected-options {
      input::placeholder {
        color: #c0c4cc;
        padding-left: 4px;
        font-size: inherit;
      }
    }
    .vs__actions {
      .el-icon-arrow-down {
        color: #c0c4cc;
      }
    }
  }
}
.related-list-filter {
  margin: 0px 8px;
  background-color: #fff;
  &-label {
    font-size: 14px;
    color: #606266;
    margin-right: 10px;
  }
  &-value {
    width: calc(100% - 60px) !important;
  }
  &-reset {
    margin-right: 8px;
  }
  &-search {
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
  .el-button+ .el-button {
    margin: 0px;
  }
}
</style>
